"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var _LifecycleRules_1 = require("./_LifecycleRules");
exports._BucketLifecycleConfiguration = {
    type: "structure",
    required: ["Rules"],
    members: {
        Rules: {
            shape: _LifecycleRules_1._LifecycleRules,
            locationName: "Rule"
        }
    }
};
//# sourceMappingURL=_BucketLifecycleConfiguration.js.map